export interface Point {
  x: number;
  y: number;
}

export interface Size {
  w: number;
  h: number;
}

export interface Rect extends Point, Size {}

export interface AssetStatus {
  [assetId: string]: {
    cropPerformed: boolean;
  };
}

export type CSSAttribute = { [key: string]: string | number };

export type ViewMode = 'normal' | 'thumbnail' | 'fullscreen';

export interface TimeUpdate {
  duration: number;
  remainingTime: number;
}

export interface TimeUpdater {
  (timeUpdate: TimeUpdate): void;
}

export interface ClickThruOptions {
  url: string;
  id: string;
  playerHandles: boolean;
}

export interface Attrs {
  linear: boolean;
  width: number;
  height: number;
  expanded: boolean;
  skippable: boolean;
  remainingTime: number;
  duration: number;
  volume: number;
  companions: string;
  icons: boolean;
  viewMode: ViewMode;
  bitrate: number;
  // extra
  quartile: 0;
}

export const Indefinite = -2;
export const Unimplemented = -1;

export interface Change {
  event: string;
  partial: Partial<Attrs>;
}

export interface Sub {
  fn: Function;
  scope: any;
}

export interface Changes {
  subs: Array<{ (change: Change): void }>;
  subscribe: (fn: { (change: Change): void }) => void;
  unsubscribe: (fn: { (change: Change): void }) => void;
  applyChange: (change: Change) => void;
}

export interface Asset {
  id: string;
  uri: string | undefined;
  time?: number;
  cacheBuster?: number | string;
  crop?: {
    rect: Rect;
    originalAsset: string;
  };
}

export interface VideoAsset {
  image: Asset;
  video: Asset;
}

export interface PostConfig {
  name: string | null;
  brand_name: string | null;
  page_id: string | null;
  logo: Asset;
  text: string | null;
  callToAction: string | null;
  destination_url: string | null;
  size: { width: number; height: number };
}

export interface FBFooterConfig {
  display_url: string | null;
  headline: string | null;
  description: string | null;
}

export type ImageConfig = { asset: Asset };
export type VideoConfig = { asset: VideoAsset };

export type IGVideoConfig = PostConfig & VideoConfig;
export type IGImageConfig = PostConfig & ImageConfig;
export type FBVideoConfig = PostConfig & VideoConfig & FBFooterConfig;
export type FBImageConfig = PostConfig & ImageConfig & FBFooterConfig;

export interface AdParameters<C> {
  creativeId: string;
  config: C;
  env: {
    asset_cdn_uri: string;
    asset_bucket_uri: string;
    studio_tag_uri: string;
  };
  assets: {
    [key: string]: {
      high?: string;
      low?: string;
    };
  };
  preview?: any;
  isMobile?: boolean;
  assetStatus: AssetStatus;
}

export enum PreviewEnvironment {
  MOBILE = 'mobile-environment',
  DESKTOP = 'desktop-environment',
  CTV = 'ctv-environment',
}
